// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Slider1_wrapper__3uslk","appear":"Slider1_appear__79Gev","title":"Slider1_title__rdJ1f","subtitle":"Slider1_subtitle__2lzay","value":"Slider1_value__1_0rh"};